import React from "react";
import { ensure, ListTableColumn, renderEnumValue, Text } from "sprint-common-web";

import { FileRecordStatus } from "../../../../common/types/FileRecordStatus";
import { FileRecordStatusDetails } from "../types/FileRecordStatusDetails";

export const renderFileRecordStatus = <T extends { statusDetails?: FileRecordStatusDetails; status: FileRecordStatus }>(
    item?: T,
    _index?: number,
    column?: ListTableColumn<T>
): React.ReactElement | null => {
    ensure(item);

    const status = renderEnumValue(FileRecordStatus, item, _index, column);

    ensure(status);

    return <Text variant={"small"}>{status}</Text>;
};
